<template>
  <v-row >
    <v-dialog
      v-model="dialogPrincipal"
      persistent
      max-width="800px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          data-cy="add-principal-input"
        >
          Agregar Links 
        </v-btn>
      </template>




    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Enlaces</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">
       
       <v-tab href="#one">
          <v-icon left>mdi-account</v-icon>
          Registro
        </v-tab>
        
        <v-tab href="#two" >
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
    </v-tabs>
         <v-tabs-items :value="tab"> 
          <!-- <div :value="tab"> -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      {{this.opcion}}
   <!-- <h3>{{this.fileData.link}}</h3>   -->


   
   
     <div ref="container">

            <h4>{{principalData.id}}</h4>  
                         

  </div>
   
  
      <v-col cols="12" md="6">
       <v-text-field
           v-model="opcion.link"
           label="Enlace"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   

      </v-col>

 <v-text-field
           v-model="opcion.descripcion"
           label="Descripción"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>

           <v-text-field
           v-model="opcion.linkPhoto"
           label="Enlace Foto"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>

         <v-text-field
           v-model="opcion.tipo"
           label="Tipo de enlace"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>

         <v-text-field
           v-model="opcion.observacion"
           label="Observación"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>


 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrarOpcion()"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="reset();"
      >
        Cancelar
      </v-btn>

       <v-btn
        color="error"
        class="mr-4"
        @click="cerrar();"
      >
        Cerrar
      </v-btn>
  
    </v-form> 
            </v-card-text>


           <v-card-text>

            <v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
      
    >
      El presente registro es responsable de almacenar información sobre el PrincipalFile.<br>
      
    </v-alert>

          </v-card-text>




          </v-card>
        </v-tab-item>

   <!--  fin item 1-->
<v-tab-item value="two">
          <v-card flat>
            <v-card-text>


  <v-btn
        color="error"
        class="mr-4"
        @click="cerrar();"
      >
        Cerrar
      </v-btn>

              

<v-text-field
            v-model="buscador" 
            placeholder="Ejemplo: Juan Perez"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda por descripcion de PrincipalFile
        </template>
          
          
          </v-text-field>



             
 <v-simple-table fixed-header>
    <template v-slot:default>

      

      <thead class="thead-dark">
        <tr>    
			
		<th scope="col">Codigo</th>
   
     <th scope="col">Enlace</th>
		<th scope="col">Descripcion</th>
    	<th scope="col">Enlace Imagen</th>
       <th scope="col">Tipo</th>
           <th scope="col">Observación</th>
            <th scope="col">Principal ID#</th>
		        <th scope="col">Editar</th>
		          <th scope="col">Eliminar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="opcion in opcionesBuscados" :key="opcion.id">       
<td>{{opcion.id}}</td>
<td>{{opcion.link}}</td>
<td>{{opcion.descripcion}}</td>
<td>{{opcion.linkPhoto}}</td>
<td>{{opcion.tipo}}</td>
<td>{{opcion.observacion}}</td>
<td>{{principalData.id}}</td>
         <td>
              <opcion-dialog :principal="principalData" :opcionData="opcion"   @opcionEdit="recibirOpcion"></opcion-dialog>
              
            </td>
            <td>
              <button @click="eliminarOpcion(opcion)" class="btn"><v-icon left>mdi-delete-forever</v-icon></button>
            </td>
     
 </tr>
      </tbody>
    </template>
  </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

        <!--  fin item 2-->
     

      </v-tabs-items> 

          <!-- </div> -->
    </v-card>
  

     </v-dialog>
  </v-row>
</template>


<script>



import principalService from "@/services/principalService.js";
import opcionService from "@/services/opcionService.js";
import { http } from "@/services/config";

import OpcionDialog from '../opcion/OpcionDialog';

export default {
     name: 'PrincipalOpcion',
     props: {
    principalData: {
      type: Object, // Tipo de dato correspondiente al objeto del principal
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    }
  },
    
  components: {
    
    OpcionDialog
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    }
  },



    data: vm => ({
      dialogPrincipal:false,
      refreshImage: false,
      server_link: "",
      archivo: null,
      fileData: {
        url: "",
      },
    valid: true,
    tab:"",
    buscador:'',
showPass: false,
  opciones: [],
  principal:{id:'',opcion:{}},
        opcion:{

id:'',
link:'',
descripcion:'',
linkPhoto:'',
tipo:'',
observacion:'',
principal:{
  "id":""
}
        },

        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
        
        
        
        
         urlRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
        
        
        
        
        
        
    
  }),
  created(){

       }
  ,mounted(){

    this.principal=this.principalData;


//  Fancybox.bind(this.$refs.container, '[data-fancybox]', {
//       ...(this.options || {}),
//     });



    // this.server_url = http.defaults.baseURL;
      this.listarPrincipalOpcion();
    
      this.tab="two";

   
    },

  methods: {
    listarPrincipalOpcion() {
     principalService
       .listarPrincipalsOpcion(this.principalData)
        .then((resposta) => {
          //console.log(resposta.data);
         this.opciones = resposta.data.opciones;
        // this.opciones=this.principal.opciones;
       })
  
       // this.opciones=principalData.opciones;


  },
    editarOpcion(opcion){

    //  console.log('Editar PrincipalFile');
      
     //
     // console.log(this.opcion);


     this.opcion.id=opcion.id;
     this.opcion.link=opcion.link;
      this.opcion.descripcion=opcion.descripcion;
       this.opcion.descripcion=opcion.descripcion;
        this.opcion.principal=this.principalData
    
   
     

      this.tab="one";
  
       console.log(opcion);

    },
    eliminarOpcion(opcion){

        if(confirm('Desea remover al opcion')){
        
        opcionService.delete(opcion).then(resposta=>{
          this.listarPrincipalOpcion();
          this.errors=[]
          this.limpiar();

        }).catch(e=>{

          this.errors =e.response.data.errors

        })

        }


        


    },
    limpiar(){

       
		this.opcion={
				id:'',
        link:'',
        descripcion:'',
        linkPhoto:'',
        tipo:'',
        observacion:''
			
         
	}

        
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
      this.removeFile();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    
    registrarOpcion() {
    

      this.opcion.principal=this.principalData;


        console.log(this.opcion);

          opcionService.save(this.opcion,this.config).then(resposta=>{
           this.limpiar();
          
              alert('Guardado exitoso!!')
              this.listarPrincipalOpcion();
               this.selectedTab="second";
          });







    },
    cerrar(){
      this.dialogPrincipal=false;
    },
  recibirOpcion:function(opcion){

      console.log('En elemento padre PrincipalOpcion despues de editar');
        console.log(opcion);
 
    }

  },
    watch: {
      fileData(val){            //download uri o descripcion
        this.opcion.link=this.fileData.name;
      },
      principalData: {
      handler(newVal, oldVal) {
        // Este método se ejecutará cada vez que cambie la propiedad principalData
        console.log('Propiedad principalData ha cambiado:', newVal, oldVal);
          this.listarPrincipalOpcion();
        // Aquí puedes realizar cualquier lógica adicional que necesites
      },
      deep: true // Indica que quieres observar los cambios en la propiedad de forma profunda
    }
  
    },
  computed:{
    
	
    opcionesBuscados() {
          return this.opciones.filter(opcion => {
            return opcion.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      }
    
  
  },
};
</script>




